import PropTypes from 'prop-types';

const SVG = ({
  style = {
    fill: '#000000',
  },
}) => (
  <svg style={style} xmlns="http://www.w3.org/2000/svg" viewBox="0 0 41.68 60">
    <path
      d="M15.48 8.07a.85.85 0 00-.48-.83.76.76 0 00-.88.12 7.38 7.38 0 00-.62.63 23.24 23.24 0 00-3.5 5.13A41.92 41.92 0 006.37 23.6a.8.8 0 001.56.4c0-.13.06-.26.09-.39a42.27 42.27 0 013.16-9.14 21.42 21.42 0 014.05-5.91 1.77 1.77 0 00.25-.46"
      fillRule="evenodd"
    />
    <path d="M41.31 30.11a73.91 73.91 0 00-2.26-10.21C36.1 8.48 29.82 0 20.84 0S5.58 8.48 2.63 19.9A73.91 73.91 0 00.37 30.11a40.14 40.14 0 00.15 12 26.17 26.17 0 003.36 8.48 19.58 19.58 0 0017 9.46 19.58 19.58 0 0017-9.46 26.17 26.17 0 003.36-8.48 40.14 40.14 0 00.07-12zm-2.08 11.14a24.9 24.9 0 01-3 7.92A17.57 17.57 0 0120.86 58a17.57 17.57 0 01-15.37-8.83 24.9 24.9 0 01-3-7.92 38.43 38.43 0 01-.13-11.14 69.74 69.74 0 012-9.53C7 9.91 12.7 2 20.82 2 29 2 34.65 9.91 37.32 20.58a69.74 69.74 0 012 9.53 38.43 38.43 0 01-.09 11.14z" />
  </svg>
);

SVG.propTypes = {
  style: PropTypes.object.isRequired,
};

export default SVG;
